import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import styles from '../daily-statements/daily-statements.styles';
import CalendarModal from '../../../components/common/calendar-modal';
import { LoadingCircle } from '../../../components/common/loading';
import SimpleDate from '../../../components/common/date';
import ReportStatement from '../report-statement';
import moment from 'moment';
import { DatePicker } from '@dbk/ui-datepicker';
import { Small} from '../../../components/common/text';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import datesAreEqual from 'date-fns/is_equal';

function currentDateText(fromDate, toDate,messages) {

  if (datesAreEqual(fromDate, toDate)) {
    return (
      <Small> {messages['app.common.show']} <SimpleDate value={fromDate}/> </Small>
    );
  }
  return (
  <Small> {messages['app.common.show']} {<SimpleDate value={fromDate}/>} {messages['app.common.to']} {<SimpleDate value={toDate}/>} </Small>
  );
}

var languageCode = 'en';

class CorrespondenceStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      outputType: 'correspondence',
      value: {
        from: moment(this.props.correspondence.startDate),
        to: moment(this.props.correspondence.endDate),
      }
    };
    this.handlePress = this.handlePress.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.props.getDailyStatementData({ outputType: this.state.outputType });
    this.renderWebView = this.renderWebView.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { correspondence } = this.props;
    if (this.props.correspondence) {
      if ((correspondence.startDate != prevProps.correspondence.startDate) ||
        (correspondence.endDate != prevProps.correspondence.endDate)
      ) {
        this.props.getDailyStatementData({ outputType: this.state.outputType });
      }
    }
  }

  handleOnChange = (range)=> {
    //console.log(range,"RANGE");
    this.setState({
      value: {
        ...this.state.value,
        ...range
      }
    })
  }

  onApply = ()=> {
    this.props.onApply(this.state.value.from.format('YYYY-MM-DD'), this.state.value.to.format('YYYY-MM-DD'));
  }

  renderWebView() {
    const { correspondenceStatementsList } = this.props.correspondence;
    const {
      i18n: { messages },
    } = this.props;

    if (this.props.report.busy == true) {
      return (
        <View style={styles.root}>
          <View style={styles.groupSelection}>
            <LoadingCircle />
          </View>
        </View>
      );
    }

    if (correspondenceStatementsList != undefined && correspondenceStatementsList != null && correspondenceStatementsList.length > 0) {
      return (
        <div className="row small-up-2 medium-up-3 large-up-4">
          <ReportStatement
            reportList={correspondenceStatementsList}
            pagefrom={'correspondence'}
          />
        </div>
      );
    } else {
      return (
        <div>
          <Large style={{ textAlign: 'center' }}>
            {messages['app.reports.noRecords']}
          </Large>
        </div>
      );
    }
  }

  handlePress(day) {
    let selectedDate = {
      "date": day.day.statementDates,
      "outputType": this.state.outputType,
      "selectedItems": day.day.noOfStatements
    }
    this.props.getDailyPdfList({ selectedDate });
  }

  onSelectDate(test) {
    this.props.correspondence.calendar.open();
  }

  render() {
    let noSelectDate = false;
    const { i18n: { messages }, auth } = this.props;
    const { startDate, endDate } = this.props.correspondence;
    if (auth.langCode && auth.langCode != null) {
      languageCode = auth.langCode.toLowerCase();
    }
    let show7DaysText = this.state.value.to.diff(this.state.value.from, 'days') === 6 ? true : false;

    return (
      <div className="minHeight">
        <div className="row">
          <div className="columns small-12 medium-12 large-12">
            <div className="module">
              <View style={styles.root}>
                <H1 secondary>
                  {messages['app.common.pageTitle.correspondence']}
                </H1>
                <div className="module columns small-12 medium-12 large-12">
                  <View style={styles.support}>
                    <div className="columns small-8 medium-8 large-8">
                      {show7DaysText &&
                        <Text secondary>
                          {messages['app.correspondence.correspondenceStatementsHeader']}
                        </Text>
                      }
                    </div>
                    <TouchableOpacity onPress={this.onSelectDate.bind(this, 'test')}>
                      <Text secondary testID="selectDate-label">{messages['app.report.selectDate']}</Text>
                    </TouchableOpacity>
                    <div className="columns small-3 medium-3 large-3">
                      <DatePicker
                            enableYearNavigation
                            enableRangeSelection
                            onChange={this.handleOnChange}
                            value={this.state.value}
                            startDate={moment().add(-1, 'year')}
                            endDate={moment()}
                            selectionStart={this.state.value.from}
                            selectionEnd={this.state.value.to}
                            onApply={this.onApply}
                        />
                      </div>
                  </View>
                </div>
                <div className="columns small-12 medium-12 large-12 small-centered medium-centered large-centered margin-top-15">
                  <View style={styles.dateSelectionBar} id="text_correspondencePage_correspondenceStatements_test">
                  <GenericDateSelectionBar
                    text={currentDateText((this.state.value.from._d).toString(), (this.state.value.to._d).toString(),messages)}
                    isEditable={this.props.correspondence.isDateBarClickable}
                    onEditPress={() => this.props.correspondence.calendar.open()}
                  />
                  </View>
                </div>
                <div className="columns margin-top-30">
                  {this.renderWebView()}
                </div>
              </View>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CorrespondenceStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  correspondence: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    setBusy: {
      $call: 'report.setBusy'
    },
    report: {
      busy: true
    },
    auth: {
      langCode: true,
    },
    correspondence: {
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      dateDisplay: true,
      isDateBarClickable: true,
      correspondenceStatementsList: true,
    },
    getDailyStatementData: {
      $call: 'daily.getDailyStatements'
    },
    getDailyPdfList:
      {
        $call: 'daily.getPdfLists'
      },
    onApply: {
      $call: 'correspondence.onCalendarDone'
    },
  },
})(CorrespondenceStatement);
